import { makeRenderManager, renderMathml } from "@pearsontechnology/bronte-lib-math/readonly";
import { resolvePackageAssetPath } from "./resolveOfflinePackageImageUrl";

const MATHJAX_CONFIG = "TeX-MML-AM_SVG";

export function buildPathToMathJax(packagePath: string): string {
  const resolvedPackagePath = resolvePackageAssetPath(packagePath);
  return `${resolvedPackagePath}/lib/MathJax2.7.7/MathJax.js?config=${MATHJAX_CONFIG}`;
}


/** Minimal state source matching bronte-lib-math's expected shape (not the CDP runtime). */
function createMathJaxStateAdapter(packagePath?: string) {
  if (!packagePath) {
    return null;
  }

  const pathToMathJax = buildPathToMathJax(packagePath);

  return {
    courseware: (_id: string) => ({
      state: () => ({
        get: async () => ({ pathToMathJax }),
      }),
    }),
    context: () => ({
      get: async () => "LEARNER",
    }),
  };
}

// Run once on viewer mount — starts MathJax.
export function initViewerMath(packagePath?: string): void {
  const mathStateSource = createMathJaxStateAdapter(packagePath);
  makeRenderManager(mathStateSource);
}

// Run after the stage HTML is in the DOM
export function renderViewerMathInContainer(container: HTMLElement | null): void {
  if (!container) return;
  try {
    renderMathml(container, true);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Failed to render MathML", e);
  }
}
